import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccountsRoutingModule } from './accounts-routing.module';
import { AuthFormComponent } from './auth-form/auth-form.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UserPhotoSquareCropperComponent } from './user-photo-square-cropper/user-photo-square-cropper.component';
import { SharedModule } from '@app/shared/shared.module';
import { UserFormComponent } from '@app/accounts/user-form/user-form.component';
import { BsDatepickerModule } from 'ngx-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import { UserInfoComponent } from '@app/accounts/user-info/user-info.component';
import { MomentModule } from 'angular2-moment';
import { InlineSVGModule } from 'ng-inline-svg';
import { RegisterPageComponent } from './register-page/register-page.component';
import { UserModerationStatusComponent } from './user-moderation-status/user-moderation-status.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { NgxMaskModule } from 'ngx-mask';
import { AuthPageComponent } from './auth-page/auth-page.component';
import { FamilyInputComponent } from './family-input/family-input.component';
import { LogoutComponent } from './logout/logout.component';

@NgModule({
  imports: [
    AccountsRoutingModule,
    BsDatepickerModule,
    CommonModule,
    FormsModule,
    InlineSVGModule,
    MomentModule,
    NgSelectModule,
    NgxMaskModule,
    ReactiveFormsModule,
    SharedModule,
  ],
  declarations: [
    AuthFormComponent,
    ChangePasswordComponent,
    UserFormComponent,
    UserInfoComponent,
    UserModerationStatusComponent,
    RegisterPageComponent,
    UserPhotoSquareCropperComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    AuthPageComponent,
    FamilyInputComponent,
    LogoutComponent,
  ],
  exports: [
    AuthFormComponent,
    UserFormComponent,
    UserInfoComponent,
    UserModerationStatusComponent,
    UserPhotoSquareCropperComponent,
    FamilyInputComponent,
  ],
})
export class AccountsModule { }



// WEBPACK FOOTER //
// ./src/app/accounts/accounts.module.ts